import { styled } from '@mui/material';

export const StyleFormContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

export default StyleFormContainer;
